import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logo from ".././assets/img/logo.png";
// import SearchIcon from ".././assets/img/icon/search_icon.png";
// import logoBlack from ".././assets/img/logo_black.png";
import { HeaderData } from "./HeaderData";
import "../assets/css/mobile-nav.css";

const Header = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [activeDropdown, setActiveDropdown] = useState(null);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
        document.body.style.overflow = !isMobileMenuOpen ? 'hidden' : 'auto';
    };

    const toggleDropdown = (index) => {
        setActiveDropdown(activeDropdown === index ? null : index);
    };

    useEffect(() => {
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, []);

    return (
        <>
            <header className="main_header_arae">
                {/* <!-- Top Bar --> */}
                <div className="topbar-area">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-6">
                                <ul className="topbar-list">

                                    <li><Link to="#!"><i className="fa fa-envelope"></i><span>her@cradlecarefoundation.org</span></Link>
                                    </li>
                                    <li><Link to="#!"><i className="fa fa-phone"></i><span>+234 813 548 1763</span></Link></li>
                                    {/* <li><Link to="#!"><span>Faqs</span></Link></li> */}
                                </ul>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <ul className="topbar-list-right">
                                    <li>
                                        <Link to="#!"><i className="fab fa-facebook"></i></Link>
                                    </li>
                                    {/* <li>
                                        <Link to="#!"><i className="fab fa-twitter-square"></i></Link>
                                    </li> */}
                                    <li>
                                        <Link to="#!"><i className="fab fa-instagram"></i></Link>
                                    </li>
                                     {/* <li>
                                        <Link to="#!"><i className="fab fa-linkedin"></i></Link>
                                    </li>  */}
                                    </ul>
                                    </div>
                                    </div>
                                    </div>
                                    </div>
                                    <div className="navbar-area">
                                        <div className="main-responsive-nav">
                                            <div className="container d-flex justify-content-between align-items-center">
                                                <div className="logo">
                                                    <Link to="/">
                                                        <img src={logo} alt="logo" />
                                                    </Link>
                                                </div>
                                                {!isMobileMenuOpen && (
                                                    <div className={`dot-menu`} onClick={toggleMobileMenu}>
                                                        <div className="inner">
                                                            <div className="circle"></div>
                                                            <div className="circle"></div>
                                                            <div className="circle"></div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* Mobile Menu */}
                    <div className={`mobile-nav-overlay ${isMobileMenuOpen ? 'active' : ''}`} onClick={toggleMobileMenu}></div>
                    <div className={`mobile-menu ${isMobileMenuOpen ? 'active' : ''}`}>
                        <button className="close-menu" onClick={toggleMobileMenu}>
                            <i className="fa fa-times"></i>
                        </button>
                        <ul className="navbar-nav">
                            {HeaderData.map((data, index) => (
                                <li className="nav-item" key={index}>
                                    {data.submenu ? (
                                        <>
                                            <Link 
                                                to={data.link} 
                                                className="nav-link dropdown-toggle"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    toggleDropdown(index);
                                                }}
                                                aria-expanded={activeDropdown === index}
                                            >
                                                {data.menu}
                                            </Link>
                                            <ul className={`dropdown-menu ${activeDropdown === index ? 'show' : ''}`}>
                                                {data.subMenuitem.map((data1, index1) => (
                                                    <li className="nav-item" key={index1}>
                                                        <Link to={data1.linkL} className="nav-link" onClick={toggleMobileMenu}>
                                                            {data1.subItem}
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        </>
                                    ) : (
                                        <Link to={data.link} className="nav-link" onClick={toggleMobileMenu}>
                                            {data.menu}
                                        </Link>
                                    )}
                                </li>
                            ))}
                        </ul>
                        <div className="mobile-menu-options mt-4">
                            <Link to="/make-donation" className="btn btn_navber w-100" onClick={toggleMobileMenu}>
                                Donate now
                            </Link>
                        </div>
                    </div>

                    {/* Desktop Menu */}
                    <div className="main-navbar">
                        <div className="container d-flex justify-content-center align-items-center">
                            <nav className="navbar navbar-expand-md navbar-light w-100">
                                <Link className="navbar-brand mx-auto" to="/">
                                    <img src={logo} alt="logo" />
                                </Link>
                                <div className={`collapse navbar-collapse mean-menu justify-content-center ${isMobileMenuOpen ? 'show' : ''}`} id="navbarSupportedContent">
                                    <ul className="navbar-nav mx-auto">
                                        {HeaderData.map((data, index) => (
                                            <li className="nav-item" key={index}>
                                                <Link to={data.link} className="nav-link">
                                                    {data.menu} {data.submenu && (<i className="fas fa-angle-down"></i>)}
                                                </Link>
                                                {data.submenu && (
                                                    <ul className="dropdown-menu">
                                                        {data.subMenuitem.map((data1, index1) => (
                                                            <li className="nav-item" key={index1}>
                                                                <Link to={data1.linkL} className="nav-link">{data1.subItem}</Link>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                    <div className="others-options d-flex align-items-center">
                                        <div className="option-item">
                                            {/* <Link to="#!" className="search-box"> <img src={SearchIcon} alt="icon" /></Link> */}
                                        </div>
                                        <div className="option-item">
                                            <Link to="/make-donation" className="btn btn_navber">Donate now</Link>
                                        </div>
                                    </div>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
            </header>
        </>
    );
}

export default Header;
